<template>
  <edit-button :edit-mode.sync="editMode" />
</template>

<script>
import { defineComponent, ref, watch } from "vue";
import { useEvent } from '../../plugins/vue-gtag';
import EditButton from "./EditButton.vue";

export default defineComponent({
  components: { 
    EditButton 
  },
  setup(){
    const editMode = ref(true);
    const gaWriteMode = useEvent('write_mode');

    watch(editMode, (newVal)=>{
      gaWriteMode(newVal)
      let el = document.getElementsByClassName("backdrop")[0];
      let pointerEventsValue = editMode.value ? 'none' : 'all';
      el.style.pointerEvents = pointerEventsValue;
    })

    return {
      editMode
    }
  }
})
</script>
